<template>
  <v-dialog width="400px" :value="value" @input="toggleModal" scrollable >
    <v-card class="error pb-2" style="border-radius: 10px">
      <v-card-text>
        <v-row>
          <v-col class="text-center py-4" cols="12" >
            <v-icon color="white" size="50">warning</v-icon>
          </v-col>
          <v-col cols="12" class="white--text text-center">
            <h4>
              {{ $t('general.doYouWantToDeleteThisRol') }}
            </h4>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
          color="white"
          outlined
          @click="toggleModal()"
        >
          {{ $t('general.cancel') }}
        </v-btn>
        <v-btn
          color="white"
          class="error--text"
          :loading="deletingUser"
          @click="submit()"
        >
          {{ $t('general.delete') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import notifications from '@/libs/notifications'
import { deleteRol } from '@/services/rolesService'
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['token', 'appUuid', 'companyUuid'])
  },
  data () {
    return {
      deletingUser: false
    }
  },
  methods: {
    async submit () {
      try {
        this.deletingUser = true
        await deleteRol(this.token, this.companyUuid, this.appUuid, this.rolId)
        this.deletingUser = false
        notifications.success(this.$t('general.rolSuccessfullyDeleted'))
        this.$emit('getRoles')
        this.toggleModal()
      } catch (e) {
        this.deletingUser = false
      }
    },
    toggleModal (value) {
      this.$emit('input', value)
    }
  },
  props: {
    rolId: {
      type: Number,
      required: true
    },
    value: {
      type: Boolean,
      default: false
    }
  }
}
</script>
